import PriceRowLuxPlusPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import { useAppSelector } from 'hooks/reduxHooks'
import getValueOffPercent from 'lib/offer/getValueOffPercent'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import { getCanViewLuxPlusBenefits, getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import { tileDesktopLayout } from './constants'
import { EmptyObject } from 'lib/object/objectUtils'

const Container = styled.div`
  display: flex;
  flex-direction: column;

  ${tileDesktopLayout} {
    align-items: end;
  }
`

interface Props {
  price: number
  memberPrice?: number
  value: number
  luxPlusOfferConfig?: App.OfferLuxPlusConfig
}

function CartReviewPriceStack(props: Props) {
  const {
    price,
    memberPrice,
    value,
    luxPlusOfferConfig = EmptyObject,
  }: Props = props

  const isLuxPlusMember = useAppSelector(state => getCanViewLuxPlusBenefits(state))
  const isLuxPlusEnabled = useAppSelector(state => getIsLuxPlusEnabled(state))
  const discountPercentage = useMemo(() =>
    getValueOffPercent(value, (isLuxPlusMember && !!memberPrice) ? memberPrice : price),
  [isLuxPlusMember, memberPrice, price, value])

  if (price === 0) {
    return null
  }

  return <Container>
    {(!isLuxPlusMember || (isLuxPlusMember && (!memberPrice || memberPrice === 0))) && <>
      {!!memberPrice && isLuxPlusEnabled && <PriceRowLuxPlusPrice
        size="S"
        memberPrice={memberPrice}
        priceFormat="preciseDollar"
        saleUnit=""
        logoPlacement="trailing"
      />}
      <PriceRowPrice
        size="S"
        price={price}
        priceFormat="preciseDollar"
        saleUnit=""
      />
    </>}
    {isLuxPlusMember && !!memberPrice && isLuxPlusEnabled && <LuxPlusPriceStack
      price={price}
      memberPrice={memberPrice}
      size="S"
      saleUnit=""
      testid="hero-price"
      offerConfig={luxPlusOfferConfig}
      mode="member-compact"
    />}
    {discountPercentage > 0 && <PriceRowValueDiscountWithCaption
      originalValue={value}
      size="M"
      discountPercentage={discountPercentage}
    />}
  </Container>
}

export default CartReviewPriceStack
